import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { initTelemetry } from "./lib/telemetry.ts";
import "maplibre-gl/dist/maplibre-gl.css";
import "./index.css";

initTelemetry();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
